import { render, staticRenderFns } from "./FBRStatusCell.vue?vue&type=template&id=2a2a617b"
import script from "./FBRStatusCell.vue?vue&type=script&lang=js"
export * from "./FBRStatusCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports